import styled from 'styled-components'

export const Screen = styled.div`
    width: 100%;
    max-width: 920px;
    padding: 8px 4px 32px;
`

export const Crumb = styled.div`
    font-size: 13px;
    color: #64748b;
    margin-bottom: 12px;

    button {
        border: 0;
        background: transparent;
        color: #0f766e;
        padding: 0;
        cursor: pointer;
        font: inherit;
    }
`

export const HeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 16px;

    h1 {
        margin: 0 0 4px;
        font-size: 22px;
    }

    p {
        margin: 0;
        color: #64748b;
        font-size: 13px;
    }
`

export const ActionRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
`

export const QuestionCard = styled.section`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 16px 18px 8px;
    margin-bottom: 14px;
`

export const QuestionTitle = styled.h2`
    margin: 0;
    font-size: 16px;
    font-weight: 650;
`

export const QuestionMeta = styled.div`
    margin: 4px 0 12px;
    color: #94a3b8;
    font-size: 12px;
    word-break: break-all;
`

export const AnswerBlock = styled.div`
    border-top: 1px solid #f1f5f9;
    padding: 12px 0 14px;
`

export const AnswerLabelRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
`

export const AnswerPill = styled.span`
    display: inline-flex;
    align-items: center;
    min-height: 28px;
    padding: 2px 10px;
    border-radius: 8px;
    background: ${({ $trigger }) => ($trigger ? '#fff7ed' : '#f8fafc')};
    color: ${({ $trigger }) => ($trigger ? '#c2410c' : '#334155')};
    font-weight: 700;
    font-size: 13px;
`

export const TriggerTag = styled.span`
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.04em;
    color: #c2410c;
`

export const Muted = styled.div`
    color: #94a3b8;
    font-size: 13px;
`

export const ChipRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    width: 100%;
`

export const Chip = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 100%;
    padding: 6px 8px 6px 10px;
    border-radius: 999px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    font-size: 13px;
    cursor: grab;

    button {
        border: 0;
        background: transparent;
        color: #94a3b8;
        cursor: pointer;
        padding: 0 2px;
        line-height: 1;
    }
`

export const NotesChip = styled(Chip)`
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
    padding: 2px 4px 2px 8px;
    font-size: 12px;
    cursor: default;
`

export const SourceBadge = styled.span`
    font-size: 10px;
    font-weight: 700;
    padding: 1px 6px;
    border-radius: 999px;
    background: ${({ $bg }) => $bg};
    color: ${({ $color }) => $color};
`

export const AddRow = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    margin-top: 10px;
    flex-wrap: wrap;
`

export const PopupBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const PopupQuestion = styled.div`
    color: #64748b;
    font-size: 13px;
    margin-bottom: 4px;
`

export const ReasonChoice = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 10px;
    border: 1px solid ${({ $checked }) => ($checked ? '#14b8a6' : '#e2e8f0')};
    background: ${({ $checked }) => ($checked ? '#f0fdfa' : '#fff')};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ $disabled }) => ($disabled ? 0.55 : 1)};
`

export const OtherField = styled.div`
    margin-top: 8px;
`

export const Hint = styled.div`
    margin-top: 8px;
    color: #64748b;
    font-size: 12px;
`

export const SuggestLabel = styled.div`
    font-size: 12px;
    font-weight: 700;
    margin: 0 0 6px;
    color: #334155;
`

export const PillWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    max-height: 168px;
    overflow: auto;
`

export const SuggestPill = styled.button`
    border: 1px dashed #99f6e4;
    background: #f0fdfa;
    color: #115e59;
    border-radius: 999px;
    padding: 5px 10px;
    font-size: 12px;
    cursor: pointer;

    &:disabled {
        opacity: 0.55;
        cursor: default;
    }
`

export const ShowAllButton = styled.button`
    margin-top: 6px;
    border: 0;
    background: transparent;
    color: #2185d0;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    padding: 0;
`

export const OwnReasonInput = styled.input`
    width: 100%;
    margin-top: 8px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    padding: 8px 10px;
    font-size: 13px;
    outline: none;
    background: #fff;

    &:focus {
        border-color: #2185d0;
    }
`

export const SelectedNotesBox = styled.div`
    box-sizing: border-box;
    width: 100%;
    min-height: 100px;
    height: auto;
    border: 1px solid rgba(34, 36, 38, 0.15);
    border-radius: 0.28571429rem;
    padding: 6px 8px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
    cursor: text;

    &:focus-within {
        border-color: #2185d0;
    }
`

export const SelectedHint = styled.div`
    color: #9ca3af;
    font-size: 13px;
    margin: 4px 2px 0;
`

export const NoteField = styled.textarea`
    &&& {
        width: 100%;
        flex: 1 1 auto;
        min-height: 24px;
        height: auto;
        margin: 0;
        padding: 2px;
        border: 0;
        border-radius: 0;
        outline: none;
        box-shadow: none;
        resize: none;
        overflow: auto;
        background: transparent;
        font-size: 14px;
        font-family: inherit;
        color: #1e293b;
    }

    &&&:focus {
        border: 0;
        outline: none;
        box-shadow: none;
        background: transparent;
    }

    &::placeholder {
        color: #9ca3af;
    }
`
